import api from './api';
import api2 from './api2';

export function enviarNotificacionValidacionIdentidad(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/validacion-identidad/enviar-notificacion`, data)
}


export function getDestinosCredito() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/obtenerDestinosCredito`)
}

export function setNewEstado(idCredito,estado) {
  return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredito}/state/${estado}`)
}

export function validacionIdentidadWhoIsWho(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/validacion-identidad/who-is-who`, data)
}

export function enviarNotificacionHabeasData(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/habeasdata`, data)
}

export function enviarNotificacionCedulaHabeasData(data) {
  return api2.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/habeasdata/identidad`, data)
}

export function getCedulaData(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/habeasdata/validarIdentificacion`, data)
}

export function getObligatorieadadImagenesCedula() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/habeasdata/obligatorioIdentificacion`)
}

export function postGenerateAutorization(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/politicAssessors/generateAuthorization`, data)
}